<template>
  <div v-show="isActive()" class="tab-body">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "TabBody",
  components: {},
  props: {
    tabName: { type: String, default: "" },
    sticky: { type: Boolean, default: false },
  },
  methods: {
    isActive: function () {
      return this.tabName && this.$parent.active === this.tabName;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.tab-body {
  padding: 8px;
  @include mq-up(md) {
    padding: 20px;
  }
  .tab-sticky & {
    padding: 20px 10px 8px;
  }
}
</style>
